<svg viewBox="3 1.5 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.7188 12.6436V18.6654C18.7171 18.8398 18.6465 19.0063 18.5223 19.1287C18.3982 19.2511 18.2306 19.3194 18.0563 19.3186H5.94375C5.76941 19.3194 5.60183 19.2511 5.47768 19.1287C5.35353 19.0063 5.2829 18.8398 5.28125 18.6654V12.6436" stroke="#080828" fill="none" stroke-width="1.23"/>
<path d="M15.3158 12.1846L12.0002 15.4971L8.68457 12.1846" stroke="#080828" stroke-width="1.23"/>
<path d="M12 15.4969V3.34375" stroke="#080828" stroke-width="1.23"/>
</svg>
